import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import './index.scss';
import LoadingIndicator from 'canvas-core-react/lib/LoadingIndicator';
import 'canvas-core-react/lib/CanvasStyles.css';
import ContextAppProvider from './ContextApi/ContextApi.js';
import LayoutApp from './components/common/Layout/Layout';

const UserInfoForm = lazy(() =>
  import('./components/containers/forms/UserInfoForm/UserInfoForm')
);
const NoOfferAnswer = lazy(() =>
  import('./components/containers/forms/NoOfferAnswer/NoOfferAnswer')
);
const FinacialAndContactInfoForm = lazy(() =>
  import(
    './components/containers/forms/FinacialAndContactInfoForm/FinacialAndContactInfoForm'
  )
);
const AvailableOffer = lazy(() =>
  import('./components/containers/forms/AvailableOffer/AvailableOffer')
);
const PortabilityForm = lazy(() =>
  import('./components/containers/forms/PortabilityForm/PortabilityForm')
);
const VoucherContainer = lazy(() =>
  import('./components/containers/forms/VoucherContainer/VoucherContainer')
);
function App() {
  return (
    <ContextAppProvider>
      <Router basename={process.env.PUBLIC_URL}>
        <LayoutApp>
          <Suspense
            fallback={
              <div className="app__loading">
                <LoadingIndicator size="extraLarge" />
              </div>
            }
          >
            <Switch>
              <Route exact path="/" component={UserInfoForm} />
              <Route exact path="/finacial-and-contact" component={FinacialAndContactInfoForm} />
              <Route exact path="/sin-ofertas" component={NoOfferAnswer} />
              <Route exact path="/ofertas-disponibles" component={AvailableOffer} />
              <Route exact path="/formulario-portabilidad" component={PortabilityForm} />
              <Route exact path="/voucher" component={VoucherContainer} />
            </Switch>
          </Suspense>
        </LayoutApp>
      </Router>
    </ContextAppProvider>
  );
}
export default App;
